import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useConditions from "../conditions/useConditions";

const useSchedulerRecommendations = () => {
  const [contextData, builder] = useContext(VariantContextData);
  const { Conditions } = useConditions();

  let variant = contextData.objects.variant;

  const SchedulerRecommendations = {
    create: async function (element, payload, options) {
      builder.create(
        "scheduler_recommendations",
        {
          ...(payload || {}),
          element_id: element ? element.id : undefined,
        },
        {
          transform: function (scheduler_recommendation) {
            scheduler_recommendation.open = true;
            return scheduler_recommendation;
          },
          callback: options ? options.callback : undefined,
        }
      );
    },

    duplicate: async function (
      og_scheduler_recommendation,
      payload,
      skip_history
    ) {
      let attributes = {
        options: og_scheduler_recommendation.options,
      };

      if (payload) {
        attributes = { ...attributes, ...payload };
      }

      builder.create("scheduler_recommendations", attributes, {
        callback: async function (scheduler_recommendation) {
          let conditions = Object.values(variant.conditions).filter(
            (condition) =>
              condition.contactable_type == "SchedulerRecommendation" &&
              condition.contactable_id == og_scheduler_recommendation.id &&
              condition.toBeDeleted !== true
          );

          conditions.forEach((condition) => {
            Conditions.duplicate(
              condition,
              {
                contactable_id: scheduler_recommendation.id,
              },
              true
            );
          });
        },
        skip_history: skip_history,
        skip_select: true,
      });
    },

    remove: (scheduler_recommendation) => {
      let message =
        "Are you sure you want to remove this scheduler recommendation? Once your changes are saved, it will be irreversibly deleted.";

      builder.remove(
        "scheduler_recommendations",
        scheduler_recommendation.id,
        message
      );
    },
  };

  let currentHook = SchedulerRecommendations;
  return { SchedulerRecommendations, currentHook };
};

export default useSchedulerRecommendations;
